export default __webpack_public_path__ + "static/media/indexxpay.90615691.png";